import MoreInfo from './MoreInfo'
import ccMoreInfoNew from './MoreInfoNew'
export let MoreInfoNew = ccMoreInfoNew
export default MoreInfo



// WEBPACK FOOTER //
// ./components/pages/order/MoreInfo/index.js